import { getLabelFromValue } from '@@viewCommonComponents/forms/options/index.js';
import {
  always,
  compose,
  defaultTo,
  equals,
  find,
  not,
  path,
  pathOr,
  prop,
  propEq,
  propOr,
  unless,
  when
} from 'ramda';
import { getLabelValueFromTable } from '@@viewHelpers/format.jsx';

export const usePaymentCardOptions = (project, getMiddleText, middleFeatures) => {
  const projectBankAccount = pathOr(path(['contacts', 0, 'bankAccounts', 0])(project), [
    'bankAccounts',
    0
  ])(project);

  const {
    PAIEMENTETREMBOURSEMENT_JOUR_PRELEVEMENT_VALEUR = [],
    PAIEMENTETREMBOURSEMENT_FREQUENCE_PAIEMENT_PRELEVEMENT_VALEUR = []
  } = middleFeatures;

  const paymentDayOptions = getLabelValueFromTable(
    'NOM',
    'CODE',
    PAIEMENTETREMBOURSEMENT_JOUR_PRELEVEMENT_VALEUR
  );
  const paymentFrequencyOptions = getLabelValueFromTable(
    'NOM',
    'CODE',
    PAIEMENTETREMBOURSEMENT_FREQUENCE_PAIEMENT_PRELEVEMENT_VALEUR
  );

  const paymentModeOptions = [
    {
      value: 'PRELEVEMENT',
      label: getMiddleText('PAIEMENTETREMBOURSEMENT_TYPE_PAIEMENT_PRELEVEMENT_LABEL')
    },
    {
      value: 'CHEQUE',
      label: getMiddleText('PAIEMENTETREMBOURSEMENT_TYPE_PAIEMENT_CHEQUE_LABEL')
    },
    {
      value: 'VIREMENT',
      label: getMiddleText('PAIEMENTETREMBOURSEMENT_TYPE_PAIEMENT_VIREMENT_LABEL')
    }
  ];

  const ifChequeHide = when(always(propEq('type', 'CHEQUE', projectBankAccount)), always('-'));
  const ifNotPrelevementHide = when(
    always(not(propEq('type', 'PRELEVEMENT', projectBankAccount))),
    always('-')
  );
  const paymentFrequencySelected = prop('debitFrequency', projectBankAccount);
  const paymentDayIsVisible = compose(
    equals('true'),
    defaultTo('true'),
    prop('AFFICHAGE_JOUR_PRELEVEMENT'),
    find(propEq('CODE', paymentFrequencySelected))
  )(PAIEMENTETREMBOURSEMENT_FREQUENCE_PAIEMENT_PRELEVEMENT_VALEUR);
  const ifDebitFrequencyHide = unless(always(paymentDayIsVisible), always('-'));

  const options = [
    [
      getMiddleText('COTISATION_PAYMENT_MODE_LABEL'),
      getLabelFromValue(propOr('-', 'type', projectBankAccount), paymentModeOptions)
    ],
    [
      getMiddleText('COTISATION_PAYMENT_FREQUENCY_LABEL'),
      getLabelFromValue(
        ifChequeHide(propOr('-', 'debitFrequency', projectBankAccount)),
        paymentFrequencyOptions
      )
    ],
    [
      getMiddleText('COTISATION_PAYMENT_DAY_LABEL'),
      getLabelFromValue(
        ifNotPrelevementHide(ifDebitFrequencyHide(propOr('-', 'debitDay', projectBankAccount))),
        paymentDayOptions
      )
    ],
    [
      getMiddleText('COTISATION_IBAN_LABEL'),
      ifNotPrelevementHide(propOr('-', 'iban', projectBankAccount))
    ]
  ];

  return options;
};
